interface Props {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  onSettings?: () => void;
  backLabel?: string;
  settingsLabel?: string;
}

/** The screen header bar (back chevron, title/subtitle, optional settings gear). */
export default function TopBar({
  title,
  subtitle,
  onBack,
  onSettings,
  backLabel = 'Back',
  settingsLabel = 'Settings',
}: Props) {
  return (
    <header className="topbar">
      {onBack && (
        <button type="button" className="icon-btn" onClick={onBack} aria-label={backLabel}>
          ←
        </button>
      )}
      <div className="topbar__text">
        {!!subtitle && <div className="topbar__subtitle">{subtitle}</div>}
        <h1 className="topbar__title">{title}</h1>
      </div>
      {onSettings && (
        <button type="button" className="icon-btn" onClick={onSettings} aria-label={settingsLabel}>
          ⚙
        </button>
      )}
    </header>
  );
}
